import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e08005bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "geo"
}
const _hoisted_2 = { class: "geo-header" }
const _hoisted_3 = {
  key: 0,
  style: {"color":"black"}
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "progress-text"
}
const _hoisted_6 = {
  key: 2,
  class: "upload-complete"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, "✔", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "phone-form"
}
const _hoisted_10 = { class: "input-group flex-nowrap shadow" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 3,
  class: "products products-admin"
}
const _hoisted_13 = { class: "product-data" }
const _hoisted_14 = { class: "info-card-block" }
const _hoisted_15 = { class: "card-name" }
const _hoisted_16 = {
  key: 0,
  class: "card-price"
}
const _hoisted_17 = { class: "card-description" }
const _hoisted_18 = { class: "card-control" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12M14,7L9,12L14,17V7Z"
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2A10,10 0 0,0 2,12M4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12M10,17L15,12L10,7V17Z"
  })
], -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img",
  width: "24",
  height: "24",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 4,
  class: "products"
}
const _hoisted_31 = { class: "product-container" }
const _hoisted_32 = { class: "product-data" }
const _hoisted_33 = { class: "info-card-block" }
const _hoisted_34 = {
  key: 0,
  class: "card-name"
}
const _hoisted_35 = {
  key: 1,
  class: "card-price"
}
const _hoisted_36 = {
  key: 2,
  class: "card-description"
}
const _hoisted_37 = { class: "card-control-client" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 1,
  class: "btn-text"
}
const _hoisted_40 = {
  key: 5,
  class: "products sign-modal-page"
}
const _hoisted_41 = {
  key: 6,
  class: "products sign-modal-page"
}
const _hoisted_42 = {
  key: 7,
  class: "phone-form"
}
const _hoisted_43 = { class: "input-group flex-nowrap shadow" }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 8,
  class: "phone-form"
}
const _hoisted_47 = { class: "input-group flex-nowrap shadow" }
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 9,
  class: "overlay-document"
}
const _hoisted_50 = {
  key: 10,
  id: "maskModal",
  class: "mask-modal"
}
const _hoisted_51 = { class: "mask-modal-content" }
const _hoisted_52 = { class: "mask-admin-choose" }
const _hoisted_53 = { class: "mask-admin-choose-item" }
const _hoisted_54 = { for: "idcard" }
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "mask-admin-choose-item" }
const _hoisted_57 = { for: "passport" }
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "mask-admin-choose-confirm" }
const _hoisted_60 = {
  key: 11,
  class: "modal-mask"
}
const _hoisted_61 = { class: "modal-container" }
const _hoisted_62 = { style: {"text-align":"center"} }
const _hoisted_63 = { class: "modal-footer" }
const _hoisted_64 = {
  key: 12,
  class: "modal-mask"
}
const _hoisted_65 = { class: "modal-container" }
const _hoisted_66 = { style: {"text-align":"center"} }
const _hoisted_67 = { class: "modal-footer" }
const _hoisted_68 = { class: "control" }
const _hoisted_69 = {
  class: "volume-meter",
  height: "88px",
  width: "88px",
  viewBox: "0 0 88 88"
}
const _hoisted_70 = ["stroke-dasharray"]
const _hoisted_71 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-mic-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M5 3a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0V3z" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z" }, null, -1))
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-mic-mute-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z" }, null, -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z" }, null, -1))
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-camera-video-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
}, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-camera-video-off-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728L.847 3.366zm9.746 11.925-10-14 .814-.58 10 14-.814.58z"
}, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 0,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14,10A3,3 0 0,0 11,13A3,3 0 0,0 14,16A3,3 0 0,0 17,13A3,3 0 0,0 14,10M14,18A5,5 0 0,1 9,13A5,5 0 0,1 14,8A5,5 0 0,1 19,13A5,5 0 0,1 14,18M14,2A2,2 0 0,1 16,4A2,2 0 0,1 14,6A2,2 0 0,1 12,4A2,2 0 0,1 14,2M19,0H9A2,2 0 0,0 7,2V18A2,2 0 0,0 9,20H19A2,2 0 0,0 21,18V2A2,2 0 0,0 19,0M5,22H17V24H5A2,2 0 0,1 3,22V4H5"
}, null, -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = {
  key: 1,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12,12A3,3 0 0,0 9,15A3,3 0 0,0 12,18A3,3 0 0,0 15,15A3,3 0 0,0 12,12M12,20A5,5 0 0,1 7,15A5,5 0 0,1 12,10A5,5 0 0,1 17,15A5,5 0 0,1 12,20M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8C10.89,8 10,7.1 10,6C10,4.89 10.89,4 12,4M17,2H7C5.89,2 5,2.89 5,4V20A2,2 0 0,0 7,22H17A2,2 0 0,0 19,20V4C19,2.89 18.1,2 17,2Z"
}, null, -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = {
  key: 0,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z"
}, null, -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 1,
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H10V20.09L12.09,18H6V16H14.09L16.09,14H6V12H18.09L20,10.09V8L14,2H6M13,3.5L18.5,9H13V3.5M20.15,13C20,13 19.86,13.05 19.75,13.16L18.73,14.18L20.82,16.26L21.84,15.25C22.05,15.03 22.05,14.67 21.84,14.46L20.54,13.16C20.43,13.05 20.29,13 20.15,13M18.14,14.77L12,20.92V23H14.08L20.23,16.85L18.14,14.77Z"
}, null, -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "green",
  class: "bi bi-record",
  viewBox: "0 0 16 16"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1A5 5 0 1 0 8 3a5 5 0 0 0 0 10z" }, null, -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "green",
  class: "bi bi-record-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
}, null, -1))
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = ["disabled"]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-camera2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 8c0-1.657 2.343-3 4-3V4a4 4 0 0 0-4 4z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12.318 3h2.015C15.253 3 16 3.746 16 4.667v6.666c0 .92-.746 1.667-1.667 1.667h-2.015A5.97 5.97 0 0 1 9 14a5.972 5.972 0 0 1-3.318-1H1.667C.747 13 0 12.254 0 11.333V4.667C0 3.747.746 3 1.667 3H2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1h.682A5.97 5.97 0 0 1 9 2c1.227 0 2.367.368 3.318 1zM2 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0zM14 8A5 5 0 1 0 4 8a5 5 0 0 0 10 0z" })
], -1))
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = ["disabled"]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi",
  viewBox: "0 0 26 26"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M6,2A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2H6M12,5A5,5 0 0,1 17,10A5,5 0 0,1 12,15A5,5 0 0,1 7,10A5,5 0 0,1 12,5M12,6C11.59,6.62 11.25,7.29 11.04,8H12.96C12.75,7.29 12.42,6.62 12,6M10.7,6.22C9.78,6.53 9,7.17 8.54,8H10C10.18,7.38 10.4,6.78 10.7,6.22M13.29,6.22C13.59,6.78 13.82,7.38 14,8H15.46C15,7.17 14.21,6.54 13.29,6.22M8.13,9C8.05,9.32 8,9.65 8,10C8,10.35 8.05,10.68 8.13,11H9.82C9.78,10.67 9.75,10.34 9.75,10C9.75,9.66 9.78,9.33 9.82,9H8.13M10.83,9C10.78,9.32 10.75,9.66 10.75,10C10.75,10.34 10.78,10.67 10.83,11H13.17C13.21,10.67 13.25,10.34 13.25,10C13.25,9.66 13.21,9.32 13.17,9H10.83M14.18,9C14.22,9.33 14.25,9.66 14.25,10C14.25,10.34 14.22,10.67 14.18,11H15.87C15.95,10.68 16,10.35 16,10C16,9.65 15.95,9.32 15.87,9H14.18M8.54,12C9,12.83 9.78,13.46 10.7,13.78C10.4,13.22 10.18,12.63 10,12H8.54M11.04,12C11.25,12.72 11.59,13.38 12,14C12.42,13.38 12.75,12.72 12.96,12H11.04M14,12C13.82,12.63 13.59,13.22 13.29,13.78C14.21,13.46 15,12.83 15.46,12H14M7,17H17V19H7V17Z"
  })
], -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-input-cursor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 5h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4v1zM6 5V4H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v-1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h4z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13A.5.5 0 0 1 8 1z"
  })
], -1))
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "bi bi-input-cursor",
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z" })
], -1))
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  class: "bi bi-input-cursor",
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z"
  })
], -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  fill: "currentColor",
  class: "bi bi-x",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" })
], -1))
const _hoisted_116 = [
  _hoisted_115
]
const _hoisted_117 = {
  key: 0,
  class: "info"
}
const _hoisted_118 = {
  key: 0,
  type: "button",
  class: "btn btn-light"
}
const _hoisted_119 = { class: "badge p-0 me-1" }
const _hoisted_120 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-mic-mute-fill consumerPaused text-dark",
  viewBox: "0 0 16 16"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z" }, null, -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z" }, null, -1))
const _hoisted_123 = [
  _hoisted_121,
  _hoisted_122
]
const _hoisted_124 = {
  key: 1,
  class: "video-block shadow"
}
const _hoisted_125 = ["srcObject"]
const _hoisted_126 = ["srcObject"]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "#fff",
  class: "bi bi-person icon",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" })
], -1))
const _hoisted_128 = {
  key: 0,
  class: "loader"
}
const _hoisted_129 = { class: "position-absolute top-50 start-50 translate-middle" }
const _hoisted_130 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  fill: "currentColor",
  class: "bi bi-person no-signal",
  viewBox: "0 0 16 16"
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" }, null, -1))
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  fill: "currentColor",
  class: "bi bi-camera-video-off-fill no-signal",
  viewBox: "0 0 16 16"
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728L.847 3.366zm9.746 11.925-10-14 .814-.58 10 14-.814.58z"
}, null, -1))
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = {
  key: 4,
  class: "loader"
}
const _hoisted_137 = ["srcObject"]
const _hoisted_138 = ["srcObject"]
const _hoisted_139 = {
  key: 8,
  class: "position-absolute top-50 start-50 translate-middle"
}
const _hoisted_140 = {
  key: 9,
  class: "info"
}
const _hoisted_141 = {
  key: 0,
  type: "button",
  class: "btn btn-light"
}
const _hoisted_142 = { class: "badge p-0 me-1" }
const _hoisted_143 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-mic-mute-fill consumerPaused text-dark",
  viewBox: "0 0 16 16"
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z" }, null, -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z" }, null, -1))
const _hoisted_146 = [
  _hoisted_144,
  _hoisted_145
]
const _hoisted_147 = {
  key: 0,
  class: "info"
}
const _hoisted_148 = {
  key: 0,
  type: "button",
  class: "btn btn-warning"
}
const _hoisted_149 = { class: "badge p-0 me-1" }
const _hoisted_150 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-mic-mute-fill consumerPaused text-dark",
  viewBox: "0 0 16 16"
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z" }, null, -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z" }, null, -1))
const _hoisted_153 = [
  _hoisted_151,
  _hoisted_152
]
const _hoisted_154 = {
  key: 1,
  class: "video-block shadow"
}
const _hoisted_155 = ["srcObject"]
const _hoisted_156 = ["srcObject"]
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "#fff",
  class: "bi bi-person icon",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" })
], -1))
const _hoisted_158 = {
  key: 0,
  class: "loader"
}
const _hoisted_159 = { class: "position-absolute top-50 start-50 translate-middle" }
const _hoisted_160 = { ref: "consumerCanvas" }
const _hoisted_161 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  fill: "currentColor",
  class: "bi bi-person no-signal",
  viewBox: "0 0 16 16"
}
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" }, null, -1))
const _hoisted_163 = [
  _hoisted_162
]
const _hoisted_164 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  fill: "currentColor",
  class: "bi bi-camera-video-off-fill no-signal",
  viewBox: "0 0 16 16"
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.961 12.365a1.99 1.99 0 0 0 .522-1.103l3.11 1.382A1 1 0 0 0 16 11.731V4.269a1 1 0 0 0-1.406-.913l-3.111 1.382A2 2 0 0 0 9.5 3H4.272l6.69 9.365zm-10.114-9A2.001 2.001 0 0 0 0 5v6a2 2 0 0 0 2 2h5.728L.847 3.366zm9.746 11.925-10-14 .814-.58 10 14-.814.58z"
}, null, -1))
const _hoisted_166 = [
  _hoisted_165
]
const _hoisted_167 = {
  key: 4,
  class: "loader"
}
const _hoisted_168 = ["srcObject"]
const _hoisted_169 = {
  key: 6,
  ref: "consumerCanvas"
}
const _hoisted_170 = ["srcObject"]
const _hoisted_171 = {
  key: 9,
  class: "position-absolute top-50 start-50 translate-middle"
}
const _hoisted_172 = {
  key: 10,
  class: "info"
}
const _hoisted_173 = {
  key: 0,
  type: "button",
  class: "btn btn-warning"
}
const _hoisted_174 = { class: "badge p-0 me-1" }
const _hoisted_175 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-mic-mute-fill consumerPaused text-dark",
  viewBox: "0 0 16 16"
}
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4.02 4.02 0 0 0 12 8V7a.5.5 0 0 1 1 0v1zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a4.973 4.973 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4zm3-9v4.879L5.158 2.037A3.001 3.001 0 0 1 11 3z" }, null, -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.486 10.607 5 6.12V8a3 3 0 0 0 4.486 2.607zm-7.84-9.253 12 12 .708-.708-12-12-.708.708z" }, null, -1))
const _hoisted_178 = [
  _hoisted_176,
  _hoisted_177
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Signpage = _resolveComponent("Signpage")!
  const _component_Popper = _resolveComponent("Popper")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.geo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('room.clientLocation.title')), 1),
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showGeo=!_ctx.showGeo))
            }, _toDisplayString(_ctx.showGeo ? _ctx.$t("room.clientLocation.hide") : _ctx.$t("room.clientLocation.open")), 1)
          ]),
          (_ctx.showGeo)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.showGeo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.me.geo), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAdmin && _ctx.uploadStart)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["upload-indicator", { 'upload-indicator-black': !_ctx.uploadStart }])
        }, [
          (!_ctx.uploadingVideoSuccess)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "progress-line",
                style: _normalizeStyle({ height: _ctx.uploadVideoProgress + '%' })
              }, null, 4))
            : _createCommentVNode("", true),
          (!_ctx.uploadingVideoSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.uploadVideoProgress) + "%", 1))
            : _createCommentVNode("", true),
          (_ctx.uploadingVideoSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.me.phoneFormOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "tel",
              onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.inputPhone && _ctx.inputPhone(...args))),
              ref: "tel",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
              maxlength: "13",
              class: "form-control",
              placeholder: "+380000000000",
              autocomplete: "tel",
              autofocus: "",
              "aria-describedby": "phone-input"
            }, null, 544), [
              [_vModelText, _ctx.phone],
              [_directive_maska, '+380#########']
            ]),
            _createElementVNode("button", {
              class: "btn btn-success",
              type: "button",
              id: "phone-input",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.sendPhone && _ctx.sendPhone(...args))),
              disabled: _ctx.optLoading
            }, _toDisplayString(_ctx.$t("room.send")), 9, _hoisted_11)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showProducts && _ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "product-container",
              key: product.id
            }, [
              _createElementVNode("div", _hoisted_13, [
                (product.image)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "card-image",
                      style: _normalizeStyle('background-image: url('+ _ctx.serverLink + product.image+');')
                    }, null, 4))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("h3", null, _toDisplayString(_ctx.parseJson(product.name).substr(0,30)), 513), [
                        [_vShow, product.name]
                      ])
                    ]),
                    (!_ctx.config.hideProduct)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("h5", null, _toDisplayString(product.price ?? ''), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.parseJson(product.description)), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_ctx.products[index - 1])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.showProductIndex = index - 1)
                    }, _hoisted_21, 8, _hoisted_19))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  onClick: ($event: any) => (_ctx.roomClient.sendProductToClient(product.id))
                }, _toDisplayString(_ctx.$t("product.send")), 9, _hoisted_22),
                (product.btns && product.btns[0])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.btns, (btn) => {
                        return (_openBlock(), _createElementBlock("span", {
                          onClick: ($event: any) => {_ctx.maskTypeValue = _ctx.parseJson(product.name);_ctx.maskTypeId = _ctx.parseJson(product.name); _ctx.callAction(btn.value)},
                          key: btn.id
                        }, _toDisplayString(_ctx.parseJson(btn.text)), 9, _hoisted_24))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.products[index + 1])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      onClick: ($event: any) => (_ctx.showProductIndex = index + 1)
                    }, _hoisted_27, 8, _hoisted_25))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showProducts=!_ctx.showProducts))
                }, _hoisted_29)
              ])
            ], 512)), [
              [_vShow, _ctx.showProductIndex === index]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.me.product)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_ctx.me.product.image)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "card-image",
                    style: _normalizeStyle('background-image: url('+ _ctx.serverLink + _ctx.me.product.image+');')
                  }, null, 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", null, [
                  (_ctx.me.product.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.parseJson(_ctx.me.product.name).substr(0,30)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.me.product.price && !_ctx.config.hideProduct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.me.product.price), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.me.product.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.parseJson(_ctx.me.product.description)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientBtn, (btn) => {
                return (_openBlock(), _createElementBlock("button", {
                  onClick: ($event: any) => (_ctx.callAction(btn.value)),
                  key: btn.id,
                  class: _normalizeClass(["custom-btn", btn.class])
                }, [
                  (btn.icon)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "btn-icon-block",
                        style: _normalizeStyle("background-image: url(" + _ctx.serverLink + btn.icon + ")")
                      }, null, 4))
                    : _createCommentVNode("", true),
                  (btn.text)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.parseJson(btn.text)), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_38))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAdmin && _ctx.me.signShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createVNode(_component_Signpage, {
            roomId: _ctx.roomId,
            isAdmin: _ctx.isAdmin,
            ref: "sign",
            onAlreadySign: _ctx.signByAdmin,
            onHideSign: _ctx.hideSign,
            onClientLogin: _ctx.clientReLogin
          }, null, 8, ["roomId", "isAdmin", "onAlreadySign", "onHideSign", "onClientLogin"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin && _ctx.me.signAdminShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createVNode(_component_Signpage, {
            roomId: _ctx.roomId,
            isAdmin: _ctx.isAdmin,
            ref: "sign",
            onHideSign: _ctx.hideSign,
            onSignedBy: _ctx.signedBy,
            onSetFullSigned: _ctx.setFullSigned
          }, null, 8, ["roomId", "isAdmin", "onHideSign", "onSignedBy", "onSetFullSigned"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.me.codeFormOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _withDirectives(_createElementVNode("input", {
              type: "number",
              ref: "code",
              onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.inputOTP && _ctx.inputOTP(...args))),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.code) = $event)),
              autofocus: "",
              maxlength: "6",
              autocomplete: "one-time-code",
              class: "form-control",
              placeholder: _ctx.$t('room.enterCode')
            }, null, 40, _hoisted_44), [
              [_vModelText, _ctx.code]
            ]),
            _createElementVNode("button", {
              class: "btn btn-success",
              type: "button",
              id: "phone-input",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.sendCode && _ctx.sendCode(...args))),
              disabled: _ctx.optLoading
            }, _toDisplayString(_ctx.$t("notifications.phone.send")), 9, _hoisted_45)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loadAudioOutputResultShow && _ctx.loadAudioOutputResult && _ctx.audioOutputDevices.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("select", {
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleOutpuAudio && _ctx.toggleOutpuAudio(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audioOutputDevices, (device) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: device.deviceId,
                  value: device.deviceId
                }, _toDisplayString(device.label), 9, _hoisted_48))
              }), 128))
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAdmin && _ctx.me.maskType)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("span", null, _toDisplayString(_ctx.me.maskType), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin && _ctx.activeMask)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("label", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: _ctx.$t('room.document1'),
                    id: "idcard",
                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.maskTypeId = 'idcard')),
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.maskTypeValue) = $event))
                  }, null, 40, _hoisted_55), [
                    [_vModelRadio, _ctx.maskTypeValue]
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.$t("room.document1")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("label", _hoisted_57, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "passport",
                    value: _ctx.$t('room.document2'),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.maskTypeId = 'passport')),
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.maskTypeValue) = $event))
                  }, null, 40, _hoisted_58), [
                    [_vModelRadio, _ctx.maskTypeValue]
                  ]),
                  _createTextVNode(_toDisplayString(_ctx.$t("room.document2")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("button", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sendMask()))
                }, _toDisplayString(_ctx.$t("room.showMask")), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAdmin && _ctx.showSaveModalBlock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.$t('saveModal.title')), 1)
              ], true)
            ]),
            _createElementVNode("footer", _hoisted_63, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("button", {
                  class: "button custom-btn yellow saveModalFontSize",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveFiles(false)))
                }, _toDisplayString(_ctx.$t('saveModal.buttons.unsave')), 1),
                _createElementVNode("button", {
                  class: "button custom-btn yellow saveModalFontSize",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveFiles(true)))
                }, _toDisplayString(_ctx.$t('saveModal.buttons.save')), 1)
              ], true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAdmin && _ctx.showLiveModalBlock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.$t('leaveModal.title')), 1)
              ], true)
            ]),
            _createElementVNode("footer", _hoisted_67, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("button", {
                  class: "button custom-btn yellow saveModalFontSize",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showLiveModal=!_ctx.showLiveModal))
                }, _toDisplayString(_ctx.$t('leaveModal.no')), 1),
                _createElementVNode("button", {
                  class: "button custom-btn yellow saveModalFontSize",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeRoom()))
                }, _toDisplayString(_ctx.$t('leaveModal.yes')), 1)
              ], true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_68, [
      _createVNode(_component_Popper, {
        content: (_ctx.producer?.audio.stream?.paused ? _ctx.$t('tooltip.on') : _ctx.$t('tooltip.off')) + ' ' + _ctx.$t('tooltip.mic'),
        hover: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-warning rounded-circle shadow-sm", { disable: _ctx.producer?.audio.stream?.paused }]),
            autocomplete: "off",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.toggleMic && _ctx.toggleMic(...args)))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_69, [
              _createElementVNode("circle", {
                r: "38",
                cx: "44",
                cy: "44",
                pathLength: "360",
                "stroke-width": "3",
                "stroke-dasharray": `${_ctx.currentProducer.audio.volume.level} 360`,
                "stroke-dashoffset": "0"
              }, null, 8, _hoisted_70)
            ])),
            (!_ctx.producer?.audio.stream?.paused)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_71, _hoisted_74))
              : _createCommentVNode("", true),
            (_ctx.producer?.audio.stream?.paused)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_75, _hoisted_78))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_Popper, {
        content: (_ctx.producer?.video.stream?.paused ? _ctx.$t('tooltip.on') : _ctx.$t('tooltip.off')) + ' ' + _ctx.$t('tooltip.webcam'),
        hover: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["btn btn-outline-warning rounded-circle shadow-sm", {
          disable: _ctx.producer?.video.stream?.paused,
        }]),
            autocomplete: "off",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleWebcam && _ctx.toggleWebcam(...args)))
          }, [
            (!_ctx.producer?.video.stream?.paused)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_79, _hoisted_81))
              : _createCommentVNode("", true),
            (_ctx.producer?.video.stream?.paused)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_82, _hoisted_84))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["content"]),
      (!_ctx.config.hideChooseDeviceBtn)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 0,
            content: _ctx.$t('tooltip.outputSound'),
            hover: true
          }, {
            default: _withCtx(() => [
              (_ctx.loadAudioOutputResult && !_ctx.config.hideChooseDeviceBtn)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-warning rounded-circle shadow-sm",
                    autocomplete: "off",
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.toggleSpeaker && _ctx.toggleSpeaker(...args)))
                  }, [
                    (_ctx.loadAudioOutputResultShow)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_85, _hoisted_87))
                      : _createCommentVNode("", true),
                    (!_ctx.loadAudioOutputResultShow)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_88, _hoisted_90))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["content"]))
        : _createCommentVNode("", true),
      (!_ctx.config.hideProductAndDocuments)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 1,
            content: !_ctx.config.hideProduct ? _ctx.$t('tooltip.product') : _ctx.$t('tooltip.documents'),
            hover: true
          }, {
            default: _withCtx(() => [
              (_ctx.isAdmin && !_ctx.config.hideProductAndDocuments)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-warning rounded-circle shadow-sm",
                    autocomplete: "off",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showProducts=!_ctx.showProducts))
                  }, [
                    (!_ctx.showProducts)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_91, _hoisted_93))
                      : _createCommentVNode("", true),
                    (_ctx.showProducts)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_94, _hoisted_96))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["content"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Popper, {
        content: (!_ctx.recordedFromClient ? _ctx.$t('tooltip.on') : _ctx.$t('tooltip.off')) + ' ' + _ctx.$t('tooltip.record'),
        hover: true
      }, {
        default: _withCtx(() => [
          (_ctx.isAdmin && _ctx.currentConsumer.video.track)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["btn btn-outline-warning rounded-circle shadow-sm", {
          disable: _ctx.producer?.video.stream?.paused,
        }]),
                autocomplete: "off",
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleRecordSecond('client')))
              }, [
                (!_ctx.recordedFromClient)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_97, _hoisted_99))
                  : _createCommentVNode("", true),
                (_ctx.recordedFromClient)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_100, _hoisted_102))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_Popper, {
        content: _ctx.$t('tooltip.photo'),
        hover: true
      }, {
        default: _withCtx(() => [
          (!_ctx.appMod && _ctx.isAdmin && _ctx.currentConsumer.video.track)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-warning rounded-circle shadow-sm",
                autocomplete: "off",
                disabled: _ctx.isActivePhoto,
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.takePhoto()))
              }, _hoisted_105, 8, _hoisted_103))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["content"]),
      (_ctx.isAdmin && _ctx.currentConsumer.video.track && false)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "btn btn-outline-warning rounded-circle shadow-sm",
            autocomplete: "off",
            disabled: _ctx.activeMask,
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.activeMask = !_ctx.activeMask))
          }, _hoisted_108, 8, _hoisted_106))
        : _createCommentVNode("", true),
      (!_ctx.config.hideOtp)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 3,
            content: _ctx.$t('tooltip.otp'),
            hover: true
          }, {
            default: _withCtx(() => [
              (_ctx.showBlocks && !_ctx.appMod && _ctx.isAdmin && !_ctx.config.hideOtp)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-outline-warning rounded-circle shadow-sm",
                    autocomplete: "off",
                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createOtp()))
                  }, _hoisted_110))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["content"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Popper, {
        content: _ctx.$t('room.sign'),
        hover: true
      }, {
        default: _withCtx(() => [
          (_ctx.isAdmin && !_ctx.fullSigned && !_ctx.me.denied && !_ctx.me.signShowedClient)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-warning rounded-circle shadow-sm",
                autocomplete: "off",
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.roomClient.signShow()))
              }, _hoisted_112))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_Popper, {
        content: _ctx.$t('room.invite'),
        hover: true
      }, {
        default: _withCtx(() => [
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-warning rounded-circle shadow-sm",
                autocomplete: "off",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.copyUrl()))
              }, _hoisted_114))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["content"]),
      _createVNode(_component_Popper, {
        content: _ctx.$t('tooltip.leave'),
        hover: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-warning rounded-circle shadow-sm",
            autocomplete: "off",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isAdmin ? _ctx.showSaveModal=!_ctx.showSaveModal : _ctx.showLiveModal=!_ctx.showLiveModal))
          }, _hoisted_116)
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({
      'producer' : !_ctx.appMod,
      'video-container' : !_ctx.appMod,
      'ratio' : !_ctx.appMod,
      'ratio-1x1' : !_ctx.appMod,
      'rounded' : !_ctx.appMod,
      'consumer' : _ctx.appMod,
      'video-container' : _ctx.appMod,
      })
    }, [
      (!_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
            (_ctx.isAdmin ? _ctx.me.displayName?.length : _ctx.peerName?.length)
              ? (_openBlock(), _createElementBlock("button", _hoisted_118, [
                  _createElementVNode("span", _hoisted_119, [
                    (
                _ctx.isAdmin
                  ? _ctx.producer?.audio.stream?.paused
                  : _ctx.consumer?.audio.stream?.remotelyPaused
              )
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_120, _hoisted_123))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.isAdmin ? _ctx.me.displayName : _ctx.peerName), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.appMod)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_124, [
            _withDirectives(_createElementVNode("video", {
              ref: "producerVideo",
              srcObject: 
            _ctx.isAdmin ? _ctx.currentProducer.video.track : _ctx.currentConsumer.video.track
          ,
              autoPlay: "",
              playsInline: "",
              muted: ""
            }, null, 8, _hoisted_125), [
              [_vShow, 
            _ctx.isAdmin
              ? _ctx.currentProducer.video.track && !_ctx.producer?.video.stream?.paused
              : _ctx.currentConsumer.video.track &&
                !_ctx.consumer?.video.stream?.remotelyPaused
          ]
            ]),
            _createElementVNode("audio", {
              ref: "producerAudio",
              srcObject: _ctx.currentProducer.audio.track,
              playsInline: ""
            }, null, 8, _hoisted_126),
            _hoisted_127,
            (
            _ctx.isAdmin
              ? _ctx.currentProducer.video.loaded && !_ctx.currentProducer.video.track
              : _ctx.currentConsumer.video.loaded && !_ctx.currentConsumer.video.track
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_128))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", {
                class: _normalizeClass(["spinner-grow text-warning", { active: _ctx.me.webcamInProgress }]),
                role: "status"
              }, null, 2)
            ])
          ], 512)), [
            [_vShow, 
          _ctx.isAdmin ||
          (!_ctx.isAdmin &&
            _ctx.currentConsumer.video.track &&
            !_ctx.consumer?.video.stream?.remotelyPaused)
        ]
          ])
        : _createCommentVNode("", true),
      (
          _ctx.appMod && (_ctx.isAdmin ? !_ctx.currentConsumer.video.track : !_ctx.currentProducer.video.track)
        )
        ? (_openBlock(), _createElementBlock("svg", _hoisted_130, _hoisted_132))
        : _createCommentVNode("", true),
      (
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.track && _ctx.producer?.video.stream?.paused
            : _ctx.currentProducer.video.track &&
              _ctx.consumer?.video.stream?.remotelyPaused
        )
        ? _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_133, _hoisted_135, 512)), [
            [_vShow, _ctx.appMod]
          ])
        : _createCommentVNode("", true),
      (_ctx.appMod &&
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.loaded && !_ctx.currentConsumer.video.track
            : _ctx.currentProducer.video.loaded && !_ctx.currentProducer.video.track
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_136))
        : _createCommentVNode("", true),
      (_ctx.appMod)
        ? _withDirectives((_openBlock(), _createElementBlock("video", {
            key: 5,
            ref: "producerVideo",
            srcObject: 
            _ctx.isAdmin ? _ctx.currentProducer.video.track : _ctx.currentConsumer.video.track
          ,
            autoPlay: "",
            playsInline: "",
            muted: ""
          }, null, 8, _hoisted_137)), [
            [_vShow, 
            _ctx.isAdmin
              ? _ctx.currentProducer.video.track && !_ctx.producer?.video.stream?.paused
              : _ctx.currentConsumer.video.track &&
                !_ctx.consumer?.video.stream?.remotelyPaused
          ]
          ])
        : _createCommentVNode("", true),
      (_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", {
            key: 6,
            class: _normalizeClass(["flash", { active: _ctx.isActivePhoto }])
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.appMod)
        ? (_openBlock(), _createElementBlock("audio", {
            key: 7,
            ref: "producerAudio",
            class: "producerAudio",
            srcObject: _ctx.currentProducer.audio.track,
            playsInline: ""
          }, null, 8, _hoisted_138))
        : _createCommentVNode("", true),
      (_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
            _createElementVNode("div", {
              class: _normalizeClass(["spinner-grow text-warning", { active: _ctx.me.webcamInProgress }]),
              role: "status"
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showBlocks && _ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
            (_ctx.isAdmin ? _ctx.me.displayName?.length : _ctx.peerName?.length)
              ? (_openBlock(), _createElementBlock("button", _hoisted_141, [
                  _createElementVNode("span", _hoisted_142, [
                    (
                _ctx.isAdmin
                  ? _ctx.producer?.audio.stream?.paused
                  : _ctx.consumer?.audio.stream?.remotelyPaused
              )
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_143, _hoisted_146))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.isAdmin ? _ctx.me.displayName : _ctx.peerName), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({
      'producer' : _ctx.appMod,
      'video-container' : _ctx.appMod,
      'ratio' : _ctx.appMod,
      'ratio-1x1' : _ctx.appMod,
      'rounded' : _ctx.appMod,
      'consumer' : !_ctx.appMod,
      'video-container' : !_ctx.appMod,
      })
    }, [
      (_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
            (_ctx.isAdmin ? _ctx.peerName?.length : _ctx.me.displayName?.length)
              ? (_openBlock(), _createElementBlock("button", _hoisted_148, [
                  _createElementVNode("span", _hoisted_149, [
                    (_ctx.isAdmin && _ctx.consumer?.audio.stream?.remotelyPaused)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_150, _hoisted_153))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.isAdmin ? _ctx.peerName : _ctx.me.displayName), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.appMod)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_154, [
            _withDirectives(_createElementVNode("video", {
              ref: "consumerVideo",
              class: _normalizeClass({ vertical: _ctx.orientationClientValue === 'portrait', 'mirror-video-mod': _ctx.mirrorClientVideo && !_ctx.isAdmin }),
              srcObject: 
          _ctx.isAdmin ? _ctx.currentConsumer.video.track : _ctx.currentProducer.video.track
        ,
              autoPlay: "",
              playsInline: "",
              muted: ""
            }, null, 10, _hoisted_155), [
              [_vShow, 
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.track &&
              !_ctx.consumer?.video.stream?.remotelyPaused
            : _ctx.currentProducer.video.track
        ]
            ]),
            _createElementVNode("audio", {
              class: "consumerAudio",
              ref: "consumerAudio",
              srcObject: _ctx.currentConsumer.audio.track,
              autoPlay: "",
              playsInline: ""
            }, null, 8, _hoisted_156),
            _hoisted_157,
            (
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.loaded && !_ctx.currentConsumer.video.track
            : _ctx.currentProducer.video.loaded && !_ctx.currentProducer.video.track
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_158))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_159, [
              _createElementVNode("div", {
                class: _normalizeClass(["spinner-grow text-warning", { active: _ctx.me.webcamInProgress }]),
                role: "status"
              }, null, 2)
            ]),
            _createElementVNode("canvas", _hoisted_160, null, 512),
            _createElementVNode("div", {
              class: _normalizeClass(["flash", { active: _ctx.isActivePhoto }])
            }, null, 2)
          ], 512)), [
            [_vShow, 
          !_ctx.isAdmin ||
          (_ctx.isAdmin &&
            _ctx.currentConsumer.video.track &&
            !_ctx.consumer?.video.stream?.remotelyPaused)
        ]
          ])
        : _createCommentVNode("", true),
      (
          !_ctx.appMod && (_ctx.isAdmin ? !_ctx.currentConsumer.video.track : !_ctx.currentProducer.video.track)
        )
        ? (_openBlock(), _createElementBlock("svg", _hoisted_161, _hoisted_163))
        : _createCommentVNode("", true),
      (
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.track && _ctx.producer?.video.stream?.paused
            : _ctx.currentProducer.video.track &&
              _ctx.consumer?.video.stream?.remotelyPaused
        )
        ? _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_164, _hoisted_166, 512)), [
            [_vShow, !_ctx.appMod]
          ])
        : _createCommentVNode("", true),
      (!_ctx.appMod &&
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.loaded && !_ctx.currentConsumer.video.track
            : _ctx.currentProducer.video.loaded && !_ctx.currentProducer.video.track
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_167))
        : _createCommentVNode("", true),
      (!_ctx.appMod)
        ? _withDirectives((_openBlock(), _createElementBlock("video", {
            key: 5,
            ref: "consumerVideo",
            class: _normalizeClass({ vertical: _ctx.orientationClientValue === 'portrait', 'mirror-video-mod': _ctx.mirrorClientVideo && _ctx.isAdmin }),
            srcObject: 
          _ctx.isAdmin ? _ctx.currentConsumer.video.track : _ctx.currentProducer.video.track
        ,
            autoPlay: "",
            playsInline: "",
            muted: ""
          }, null, 10, _hoisted_168)), [
            [_vShow, 
          _ctx.isAdmin
            ? _ctx.currentConsumer.video.track &&
              !_ctx.consumer?.video.stream?.remotelyPaused
            : _ctx.currentProducer.video.track
        ]
          ])
        : _createCommentVNode("", true),
      (!_ctx.appMod)
        ? (_openBlock(), _createElementBlock("canvas", _hoisted_169, null, 512))
        : _createCommentVNode("", true),
      (!_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", {
            key: 7,
            class: _normalizeClass(["flash", { active: _ctx.isActivePhoto }])
          }, null, 2))
        : _createCommentVNode("", true),
      (!_ctx.appMod)
        ? (_openBlock(), _createElementBlock("audio", {
            key: 8,
            class: "consumerAudio",
            ref: "consumerAudio",
            srcObject: _ctx.currentConsumer.audio.track,
            autoPlay: "",
            playsInline: ""
          }, null, 8, _hoisted_170))
        : _createCommentVNode("", true),
      (!_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
            _createElementVNode("div", {
              class: _normalizeClass(["spinner-grow text-warning", { active: _ctx.me.webcamInProgress }]),
              role: "status"
            }, null, 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showBlocks && !_ctx.appMod)
        ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
            (_ctx.isAdmin ? _ctx.peerName?.length : _ctx.me.displayName?.length)
              ? (_openBlock(), _createElementBlock("button", _hoisted_173, [
                  _createElementVNode("span", _hoisted_174, [
                    (_ctx.isAdmin && _ctx.consumer?.audio.stream?.remotelyPaused)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_175, _hoisted_178))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.isAdmin ? _ctx.peerName : _ctx.me.displayName), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}